exports.content = `# Disclaimer

Created : 2019-12-02

**Warning**

Excessive Hangboard Training is Dangerous

By using HangBird you are acklowledging that you understand the risks and agree that the creators of HangBird are not liable for any injuries that may occur during the course of training.`
